import {useSuspenseQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getFiveStars} from '../../services/getFiveStars';

export const useGetFiveStarsQuery = () =>
	useSuspenseQuery({
		queryKey: [QUERY_KEYS.FIVE_STARS],
		queryFn: ({signal}) => getFiveStars({signal}),
	});
